import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';

import { LayoutDataService } from './layout-data.service';
import { MapDataService } from './map-data.service';
import { PlaceDataService } from './place-data.service';
import { SeriesDataService } from './series-data.service';
import { SeriesMapDataService } from './series-map-data.service';
import { SeriesSubscriptionDataService } from './series-subscription-data.service';
import { inject } from '@angular/core';

export const DataResolverService: ResolveFn<boolean> = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  layoutData: LayoutDataService = inject(LayoutDataService),
  mapData: MapDataService = inject(MapDataService),
  placeData: PlaceDataService = inject(PlaceDataService),
  seriesData: SeriesDataService = inject(SeriesDataService),
  seriesMapData: SeriesMapDataService = inject(SeriesMapDataService),
  seriesSubscriptionData: SeriesSubscriptionDataService = inject(
    SeriesSubscriptionDataService,
  ),
) => {
  // TODO:
  // use this to insure data is loaded prior to visiting page so it isn't blank.
  //
  // I don't remember how to reproduce this issue:
  // This causes data loss if the user is loaded afterward
  // because the sync wipes the data due to a call to logout.
  try {
    // load() cache's data so API calls are not made if data is already loaded.
    await placeData.load();
    await mapData.load();
    await seriesData.load();
    await seriesMapData.load();
    await seriesSubscriptionData.load();
    await layoutData.load();
    return true;
  } catch {
    return false;
  }
};
